<template>
  <div class="sidebar-wrapper">
    <div class="sidebar-link-wrapper">
      <div class="payment-section">
        <div class="link-wrapper">
          <router-link
            v-if="userInfo.userRole === 'CUSTOMER' && !customerToProfessionalId"
            to="/client-dashboard"
            aria-current="page"
            :class="
              isActive('/client-dashboard')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/home.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/client-dashboard')"
            />
            <img
              src="@/assets/timeslot-images/home-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Dashboard</div>
            <!--          <div class="text-block-12 inactive">Dashboard</div>-->
          </router-link>
          <router-link
            v-else
            to="/professional-dashboard"
            aria-current="page"
            :class="
              isActive('/professional-dashboard')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/home.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/professional-dashboard')"
            />
            <img
              src="@/assets/timeslot-images/home-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Dashboard</div>
            <!--          <div class="text-block-12 inactive">Dashboard</div>-->
          </router-link>
        </div>
        <div class="link-wrapper">
          <router-link
            v-if="userInfo.userRole === 'CUSTOMER' && !customerToProfessionalId"
            to="/customer-messages"
            :class="
              isActive('/customer-messages')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/sms.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/customer-messages')"
            />
            <img
              src="@/assets/timeslot-images/sms-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Messages</div>
          </router-link>
          <router-link
            v-else
            to="/professional-messages"
            :class="
              isActive('/professional-messages')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/sms.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/professional-messages')"
            />
            <img
              src="@/assets/timeslot-images/sms-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Messages</div>
          </router-link>
        </div>
        <div class="link-wrapper">
          <router-link
            v-if="userInfo.userRole === 'CUSTOMER' && !customerToProfessionalId"
            to="/customer-bookings"
            :class="
              isActive('/customer-bookings')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/timer.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/customer-bookings')"
            />
            <img
              src="@/assets/timeslot-images/timer-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Bookings</div>
          </router-link>
          <router-link
            v-else
            to="/professional-bookings"
            :class="
              isActive('/professional-bookings')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/timer.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/professional-bookings')"
            />
            <img
              src="@/assets/timeslot-images/timer-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Bookings</div>
          </router-link>
        </div>
        <div class="link-wrapper">
          <router-link
            v-if="userInfo.userRole === 'CUSTOMER' && !customerToProfessionalId"
            to="/customer-subscriptions"
            :class="
              isActive('/customer-subscriptions')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/subscribe.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/customer-subscriptions')"
            />
            <img
              src="@/assets/timeslot-images/subscribe-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Subscriptions</div>
          </router-link>
          <router-link
            v-else
            to="/professional-subscriptions"
            :class="
              isActive('/professional-subscriptions')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/subscribe.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/professional-subscriptions')"
            />
            <img
              src="@/assets/timeslot-images/subscribe-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Subscriptions</div>
          </router-link>
        </div>
        <div
          class="link-wrapper"
          v-if="
            userInfo.userRole === 'PROFESSIONAL' || customerToProfessionalId
          "
        >
          <router-link
            to="/professional-availability"
            :class="
              isActive('/professional-availability')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/availability-icon.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/professional-availability')"
            />
            <img
              src="@/assets/timeslot-images/availability-icon-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Available Slots</div>
          </router-link>
        </div>
        <!--        <div class="link-wrapper">-->
        <!--          <router-link-->
        <!--            to="/customer-feeds"-->
        <!--            :class="-->
        <!--              isActive('/customer-feeds')-->
        <!--                ? 'nav-link-wrapper-active w-inline-block'-->
        <!--                : 'nav-link-wrapper w-inline-block'-->
        <!--            "-->
        <!--          >-->
        <!--            <img-->
        <!--              src="@/assets/timeslot-images/trend-up.svg"-->
        <!--              loading="lazy"-->
        <!--              alt=""-->
        <!--              class="image-5"-->
        <!--              v-if="!isActive('/customer-feeds')"-->
        <!--            />-->
        <!--            <img-->
        <!--              src="@/assets/timeslot-images/trend-up-active.svg"-->
        <!--              loading="lazy"-->
        <!--              alt=""-->
        <!--              class="image-5"-->
        <!--              v-else-->
        <!--            />-->
        <!--            <div>Feeds</div>-->
        <!--          </router-link>-->
        <!--        </div>-->
        <div class="link-wrapper">
          <router-link
            v-if="userInfo.userRole === 'CUSTOMER' && !customerToProfessionalId"
            to="/customer-classes"
            :class="
              isActive('/customer-classes')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/class-inactive.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/customer-classes')"
            />
            <img
              src="@/assets/timeslot-images/class-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>My Classes</div>
          </router-link>
          <router-link
            v-else
            to="/professional-classes"
            :class="
              isActive('/professional-classes')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/class-inactive.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/professional-classes')"
            />
            <img
              src="@/assets/timeslot-images/class-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>My Classes</div>
          </router-link>
        </div>
        <div class="link-wrapper">
          <router-link
            to="/wallet"
            :class="
              isActive('/wallet')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/wallet.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/wallet')"
            />
            <img
              src="@/assets/timeslot-images/wallet-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Wallet</div>
          </router-link>
        </div>

        <div class="link-wrapper">
          <router-link
            v-if="userInfo.userRole === 'CUSTOMER' && !customerToProfessionalId"
            to="/customer-settings"
            :class="
              isActive('/customer-settings')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/setting-2.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/customer-settings')"
            />
            <img
              src="@/assets/timeslot-images/setting-2-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Settings</div>
          </router-link>
          <router-link
            v-else
            to="/professional-settings"
            :class="
              isActive('/professional-settings')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/setting-2.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/professional-settings')"
            />
            <img
              src="@/assets/timeslot-images/setting-2-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Settings</div>
          </router-link>
        </div>
        <div class="link-wrapper">
          <router-link
            v-if="userInfo.userRole === 'CUSTOMER' && !customerToProfessionalId"
            to="/customer-support"
            :class="
              isActive('/customer-support')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/alarm.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/customer-support')"
            />
            <img
              src="@/assets/timeslot-images/alarm-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Support</div>
          </router-link>
          <router-link
            v-else
            to="/professional-support"
            :class="
              isActive('/professional-support')
                ? 'nav-link-wrapper-active w-inline-block'
                : 'nav-link-wrapper w-inline-block'
            "
          >
            <img
              src="@/assets/timeslot-images/alarm.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-if="!isActive('/professional-support')"
            />
            <img
              src="@/assets/timeslot-images/alarm-active.svg"
              loading="lazy"
              alt=""
              class="image-5"
              v-else
            />
            <div>Support</div>
          </router-link>
        </div>
        <div class="link-wrapper" @click="logout">
          <div class="nav-link-wrapper logout-link">
            <img
              src="@/assets/timeslot-images/logout.svg"
              loading="lazy"
              alt=""
              class="image-5"
            />
            <div class="text-block-12">Logout</div>
          </div>
          <div
            data-animation="default"
            data-collapse="medium"
            data-duration="400"
            data-easing="ease"
            data-easing2="ease"
            role="banner"
            class="navbar-2 w-nav"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import { mapState } from "vuex";

export default {
  name: "TimeslotSidebar",
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      professionals: state => state.professional.professionals,
      professionalId: state => state.professional.professionalId,
      customerInfo: state => state.customer.customerInfo,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId
    })
  },
  methods: {
    isActive(route) {
      return this.$route.path === route || this.$route.path.startsWith(route);
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    }
  }
};
</script>

<style scoped>
.logout-link {
  cursor: pointer;
}
</style>
